function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "iconInfo");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop_1920",
  stroke: "none",
  strokeWidth: 1,
  fill: "#00266E",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home",
  transform: "translate(-565.000000, -250.000000)"
}, React.createElement("g", {
  id: "iconInfo",
  transform: "translate(565.000000, 250.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#00266E",
  cx: 8,
  cy: 8,
  r: 8
}), React.createElement("path", {
  d: "M8.06944444,4.33165829 C8.06944444,3.89614523 8.22453549,3.56532776 8.53472222,3.33919598 C8.84490896,3.1130642 9.25462708,3 9.76388889,3 C10.1712983,3 10.4791656,3.07118857 10.6875,3.21356784 C10.8958344,3.35594711 11,3.56951281 11,3.85427136 C11,4.23953291 10.8379646,4.55360013 10.5138889,4.79648241 C10.1898132,5.0393647 9.78240986,5.16080402 9.29166667,5.16080402 C8.89351653,5.16080402 8.59027882,5.08961545 8.38194444,4.94723618 C8.17361007,4.80485691 8.06944444,4.59966633 8.06944444,4.33165829 Z M7.48611111,7.3718593 C7.53240764,7.26298103 7.55555556,7.15829196 7.55555556,7.05778894 C7.55555556,6.91540967 7.49074139,6.84422111 7.36111111,6.84422111 C7.21296222,6.84422111 7.07870431,6.90284698 6.95833333,7.0201005 C6.83796236,7.13735402 6.71759319,7.3425446 6.59722222,7.63567839 L6.27777778,8.40201005 L6.01388889,8.40201005 L6.40277778,7.42211055 C6.74537208,6.55945967 7.43518,6.1281407 8.47222222,6.1281407 C8.97222472,6.1281407 9.33796181,6.23701734 9.56944444,6.45477387 C9.80092708,6.6725304 9.91666667,6.94890955 9.91666667,7.2839196 C9.91666667,7.46817513 9.87963,7.66917814 9.80555556,7.88693467 L8.36111111,11.7562814 C8.31481458,11.8986607 8.29166667,11.9991622 8.29166667,12.0577889 C8.29166667,12.2085435 8.37036958,12.2839196 8.52777778,12.2839196 C8.79629764,12.2839196 9.04166556,12.0201031 9.26388889,11.4924623 L9.55555556,10.7889447 L9.81944444,10.7889447 L9.47222222,11.7060302 C9.13888722,12.568681 8.47685681,13 7.48611111,13 C7.01388653,13 6.64814944,12.8994985 6.38888889,12.6984925 C6.12962833,12.4974864 6,12.2001695 6,11.8065327 C6,11.5385246 6.06944375,11.2160823 6.20833333,10.839196 L7.48611111,7.3718593 Z",
  id: "i",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgIconInfoBlue = function SvgIconInfoBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconInfoBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconInfo-blue.56a7b47b.svg";
export { ForwardRef as ReactComponent };